export const calculatorContent = {
  eyebrow: "Calculator",
  title: "Digitise Your Hidden Losses",
  subtitle:
    "Most roofers know their marketing costs, but never calculate the hidden revenue lost to slow 24/7 response times.",
  budgetLabel: "Monthly Marketing / Ads Budget ($)",
  contractLabel: "Average Signed Contract Value ($)",
  budgetDefault: "$5,000",
  contractDefault: "$12,000",
  budgetSlider: { min: 0, max: 50000, step: 100 },
  contractSlider: { min: 0, max: 100000, step: 500 },
  rows: {
    leads: "Estimated Monthly Inbound Leads",
    lost: "Contracts Lost to Speed Gap",
    leakage: "Monthly Revenue Leakage",
  },
}
